import 'babel-polyfill';
import 'whatwg-fetch';
import './../sass/style.scss';

import Vue from 'vue';
import VueAnalytics from 'vue-analytics';

import router from './router';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import videoModal from './components/ui/video-modal.vue'
import hoodModal from './components/ui/hood-modal.vue'

Vue.component(videoModal.name, videoModal)
Vue.component(hoodModal.name, hoodModal)

// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.use(VueAnalytics, {
    id: 'UA-111955736-3',
    checkDuplicatedScript: true,
    set: [
        { field: 'appName', value: 'Web App' }
    ]
});

import App from '@/components/app.vue';
import { loadFetchDB, loadFallbackDB, showOptions, getDatabase, isWebApp } from './api/index';
import { setServiceWorker } from './api/backend/fetch';


//Check if we're in App mode and select a database

//If SW supported, use it,
//Else if apple, use pouchDB
//Else, fallback to fetch

let _dbInstalled = null;
if (isWebApp()) {
    if ('serviceWorker' in navigator) {
        //We have a service worker, let's use that
        //Connect service worker
        
        _dbInstalled = navigator.serviceWorker.register('./service-worker.js').then(reg => {
            return new Promise( resolve => {
                //If active worker found, use it and carry on
                if (reg.active != null) {
                    setServiceWorker(reg.active);
                    resolve();
                } else {
                    console.log('SW waiting', reg);
                    //No active worker yet, wait for it to go active then load it and carry on.
                    navigator.serviceWorker.addEventListener('controllerchange', () => {
                        setServiceWorker(reg.active);
                        resolve();
                    })
                }
                //Catch any updates, and reload app if nessecary.
                reg.addEventListener('updatefound', () => {
                    const newWorker = reg.installing;
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state == 'installed' && reg.active != null) {
                            //TODO: Notify of update
                            alert('Update detected, reloading page.'); //eslint-disable-line no-alert
                            location.reload(true);
                        }

                    })

                })
            })

        })

        loadFetchDB();
        showOptions(true);

    } else {
        //We're in some sort of app mode that doesn't have Service Workers, fallback to pouchDB
        location.hash = '#/';
        loadFallbackDB();
        showOptions(true);
        _dbInstalled = Promise.resolve();
    }
} else {
    // No application support detected, most likely in a browser
    // Use fetch() and disable the options page.
    loadFetchDB();
    showOptions(false);
    _dbInstalled = Promise.resolve();
}
_dbInstalled.then(() => {
    getDatabase().isFirstRun().then(isFirstRun => {
        console.log('Is first run of app?', isFirstRun);
        if (isFirstRun && isWebApp()) {
            //Precache
            location.hash = '#/first-run';
        }

        new Vue({
            router,
            el: '#app',
            template: '<app />',
            components: {
                app: App
            }

        })

    })
})


// WEBPACK FOOTER //
// ./src/index.js